import React, { useCallback, useRef, useState } from "react";
import AudioDisplay from "./audioDisplay";
import PlayerControls from "./controls";
import PlayerNavigate from "./navigate";
import PlayerProgressBar from "./progressBar";
import { SIZES_CLIP } from "./utils/constantsPlayer";
import VideoDisplay from "./videoDisplay";
function MediaPlayer(props) {
    const { source, type } = props;
    const [duration, setDuration] = useState(0);
    const [timeProgress, setTimeProgress] = useState(0);
    const mediaRef = useRef(null);
    const progressBarRef = useRef(null);
    const navigateToSegment = useCallback((segment) => {
        if (mediaRef.current) {
            mediaRef.current.currentTime = segment;
        }
    }, [mediaRef]);
    const handleLoadedMetaData = useCallback(() => {
        var _a;
        const seconds = (_a = mediaRef.current) === null || _a === void 0 ? void 0 : _a.duration;
        setDuration(Number(seconds));
        if (progressBarRef.current != null) {
            progressBarRef.current.max = String(seconds);
        }
    }, [mediaRef]);
    if (!source)
        return null;
    return (React.createElement("div", { className: "bg-gray-700 border-rounded-base" },
        React.createElement("div", { className: "p-0_25" },
            type === "audio" ? (React.createElement(AudioDisplay, { currentTrack: source, mediaRef: mediaRef, setDuration: setDuration, progressBarRef: progressBarRef })) : (React.createElement(VideoDisplay, { currentTrack: source, handleLoadedMetaData: handleLoadedMetaData, mediaRef: mediaRef, heightVideoClip: SIZES_CLIP.heightVideoClip, widthVideoClip: SIZES_CLIP.widthVideoClip })),
            React.createElement(PlayerProgressBar, { timeProgress: timeProgress, progressBarRef: progressBarRef, mediaRef: mediaRef }),
            React.createElement(PlayerNavigate, { duration: duration, setSegment: navigateToSegment }),
            React.createElement(PlayerControls, { mediaRef: mediaRef, progressBarRef: progressBarRef, setTimeProgress: setTimeProgress }))));
}
export default MediaPlayer;
